import styled from "styled-components";

export const WalletWrapper = styled.div`
  width: 100%;
  padding: 2rem 1rem;
  padding-bottom: 10rem;

  @media (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .table {
    width: 100%;
    margin-top: 2rem;

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      margin-top: 5rem;
    }

    @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
      margin-top: 5rem;
      /* padding-top: 5rem; */
    }
  }
`;

export const ViewWallet = styled.div`
  width: 100%;
  max-width: 60rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background-color: ${({ theme }) => theme.bg.prim_500};
  border-radius: 0.5rem;
  color: ${({ theme }) => theme.text.prim_100};
  padding: 2rem 4rem;

  h1 {
    font-weight: 600;
  }

  .details {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 3rem;
    margin-bottom: 1rem;

    .detail {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      h3 {
        font-weight: 500;
        color: ${({ theme }) => theme.text.prim_100};
      }

      span {
        color: ${({ theme }) => theme.text.prim_200};
      }
    }

    @media (max-width: ${({ theme }) => theme.screen.mobile}) {
      grid-template-columns: 1fr;
    }

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: ${({ theme }) => theme.screen.smallScreen}) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .preview-control {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    margin-top: 2rem;

    .ack {
      width: 100%;
    }
  }
`;
